export default {
  报价管理: "Quote Management",
  样品管理: "Sample Management",
  脚本审核: "Script Review",
  草稿审核: "Draft Review",
  交付内容: "Delivery Content",
  打款信息: "Payment Information",
  商单PM: "Campaign PM",
  "复制成功！": "Copied!",
  "商单已交付或已取消，不可操作，已为您刷新页面！":
    "Campaign is delivered or cancelled. Page refreshed.",
  达人要求: "Creator Requirements",
  粉丝量: "Follower Count",
  目标接单达人数: "Target Accepted Creators",
  "平均预算/达人": "Average Budget/Creator",
  目标总预算: "Total Budget",
  邀约达人时间: "Invite Creator Time",
  目标交付时间: "Target Delivery Time",
  查看详情: "View Details",
  邀约中: "Inviting",
  已接单: "Accepted",
  已取消: "Cancelled",
  达人唯一名: "Unique Creator Name",
  达人昵称: "Creator Nickname",
  达人: "Creator",
  粉丝数: "Followers",
  邀约报价: "Offer Price",
  操作: "Actions",
  修改报价: "Modify Offer",
  复制邀请链接: "Copy Invite Link",
  取消邀约: "Cancel Invitation",
  新增邀约达人: "Add Creator",
  邀约达人: "Invite Creator",
  已邀约达人不可重复添加: "Creator already invited",
  请输入TikTok账号唯一名: "Enter TikTok username",
  请输入金额: "Enter amount",
  修改后达人的商单邀请将同步更新: "Invitation will update",
  请输入取消邀约理由: "Reason for cancellation",
  "最多可输入100个字，请简短说说为什么。": "Max 100 characters",
  "取消成功！": "Cancelled!",
  "修改成功！": "Edited!",
  "添加成功！": "Added!",
  "达人已申请样品，不可取消接单！": "Sample requested, cannot cancel",
  导出数据: "Export Data",
  接单达人: "Accepted Creator",
  选择操作: "Select Action",
  修改最终报价: "Edit Final Price",
  取消接单: "Cancel Acceptance",
  新增接单达人: "Add Accepted Creator",
  已接单达人不可重复添加: "Creator already accepted",
  "该达人已接单您的邀请，请勿重复添加！": "Already accepted",
  接单报价: "Final Price",
  "请和达人确认后修改，否则由PIC自行承担责任！": "Confirm with creator first",
  最终报价: "Final Price",
  请输入取消接单理由: "Enter cancellation reason",
  接单时间: "Acceptance Time",
  取消时间: "Cancel Time",
  取消理由: "Reason",
  "自动取消，已被其他PIC谈成！": "Auto cancel, accepted by others PIC's invitation",
  商单已交付: "Campaign Delivered",
  待申样: "Pending Sample Request",
  已申样: "Sample Requested",
  申请样品: "Request Sample",
  商单: "Budget Campaign",
  新建样品订单: "New Sample Order",
  报价: "Offer",
  申样达人名称: "Creator Name",
  可履约方式: "Fulfillment Method",
  "该达人粉丝数＜20K": "Creator has <20K followers",
  收件人姓名: "Recipient Name",
  收件人电话: "Recipient Phone",
  地区: "Region",
  详细地址: "Detailed Address",
  "请输入街道名称，公寓名称，房间号": "Please enter street name, apartment name, and room number",
  商单商品: "Campaign Product",
  商品ID: "Product ID",
  添加规格: "Add Specification",
  规格: "Spec",
  数量: "Quantity",
  请输入有效的手机号: "Please enter a valid phone number",
  申样数量: "Sample Quantity",
  样品详情: "Sample Details",
  追加申样: "Add Sample Request",
  待审核: "Pending Review",
  待发货: "Pending Shipment",
  待履约: "Pending Fulfillment",
  已拒绝: "Rejected",
  合格: "Approved",
  不合格: "Rejected",
  待上传: "Pending Upload",
  待收款: "Pending Payment",
  已收款: "Paid",
  交付视频: "Delivery Video",
  标题: "Title",
  Hashtag达标: "Hashtag Valid",
  挂链正确: "Product Link",
  时长达标: "Duration Valid",
  "Ads Code": "Ads Code",
  播放量: "Views",
  "销量（TAP link）": "Units sold（Product link）",
  校验人: "Reviewer",
  系统自动: "System Auto",
  人工校验: "Manual Review",
  其他理由: "Other Reason",
  确认合格: "Confirm Pass",
  重新上传: "Reupload",
  确认商单商品合格: "Confirm Cotents Qualified",
  "请勾选以下要求，人工确认已合格": "Confirm checklist before approval",
  Hashtag: "Hashtag",
  "TAP link": "Product Link",
  视频时长: "Video Duration",
  交付视频合格: "Video Qualified",
  "该视频将标记为合格视频，你还要继续吗？":
    '<span style="color: red">This video will be marked qualified</span>, continue?',
  "请勾选以理由，将在APP展示给达人": "Select reasons to show in app",
  Hashtag错误: "Hashtag Error",
  "TAP link未挂链": "TAP link not linked",
  视频时长未达标: "Video duration not met",
  "Ads Code未填或填写错误": "Ads Code not filled or incorrect",
  不超过20个字: "No more than 20 characters",
  不合格理由: "Failure Reason",
  "请输入该视频的Ads Code": "Enter Ads Code",
  仅展示信息有误: "Only display information error",
  履约状态: "Fulfillment Status",
  已交付: "Delivered",
  应付商单费用: "Campaign Payment Due",
  收款类型: "Payment Type",
  未上传: "Not Uploaded",
  信息有误: "Incorrect Info",
  个人: "Individual",
  公司: "Company",
  银行信息: "Bank Info",
  收款人: "Recipient",
  收款银行: "Bank Name",
  收款卡号: "Bank Account",
  查看凭证: "View Proof",
  手机号: "Tel. Number",
  身份证信息: "ID Info",
  姓名: "Name",
  性别: "Gender",
  称呼: "Title",
  身份证号: "ID Number",
  身份证居住地址: "ID Address",
  营业执照: "Business License",
  添加收款信息: "Add Payment Info",
  编辑收款信息: "Edit Payment Info",
  "必填项未填！": "Required Field Missing!",
  个人收款: "Personal",
  公司收款: "Company",
  收款信息: "Payment Info",
  联系电话: "Contact Number",
  收款人性别: "Recipient Gender",
  小姐: "Miss",
  女士: "Ms.",
  先生: "Mr.",
  身份证姓名: "ID Name",
  请输入身份证居住地址: "Please enter ID residence address",
  身份证号码: "ID Number",
  银行卡号: "Bank Account",
  身份证照片: "ID Image",
  银行信息截图: "Bank Info Image",
  确认通过: "Confirm Approval",
  "确认收款信息无误可以打款，你还要继续吗？":
    '<span style="color: red">Confirm info is correct to proceed payment</span>',
  收款信息有误: "Payment Info Error",
  "请填写理由，将在APP展示给达人": "Please enter reason to show in app",
  不超过50个字: "Max 50 Characters",
  银行信息凭证: "Bank Info Proof",
  银行凭证: "Bank Proof",
  关闭: "Close",
  保存: "Save",
  居住地址: "Residence Address",
  "该信息已审核通过或已打款，不可保存修改内容":
    "This information has been approved or paid, cannot save changes",
  营业执照凭证: "Business License Proof",
  收款信息审核人: "Payment Reviewer",
  导入数据: "导入数据",
  确认打款: "Confirm Payment",
  请输入打款时间: "Enter Payment Time",
  打款时间: "Payment Time",
  打款类型: "Payment Type",
  打款操作人: "Payment Operator",
  通过: "Approved",
  已打款: "Paid",
  系统审核中: "System Reviewing",
  身份证凭证: "身份证凭证",
  修改收款信息: "Edit Payment Info",
  公司营业执照: "Company License",
  收款人称呼: "Recipient Title",
  进行中: "In Progress",
  "申样成功，请前往样品申样查看！": "Sample request successful, please check in sample requests!",
  前往样品申样: "Go to Sample Requests",
  "操作成功！": "Operation successful!",
  请勾选所有要求: "Select all requirements",
  必需: "Required",
  非必需: "Not Required",
  商单报价: "Campaign Offer",
  VAT: "VAT",
  商单总价: "Campaign Total Price",
  含VAT: "Including VAT",
  WHT: "WHT",
  代扣税额: "Withholding Tax",
  应打款金额: "Amount Payable",
  "Net Pay": "Net Pay",
  含税: "Tax Included",
  请输入有效的银行卡号: "Please enter a valid bank card number",
  请输入有效的身份证号: "Please enter a valid ID number",
  已完成: "Completed",
  待打款: "Pending Payment",
  总订单数: "Total Orders",
  请人工校验: "Manual review required",
  刷新: "Refresh",
  成功商品数: "Success Goods Number",
  失败商品数: "Failure Goods Number",
  个税: "Income Tax",
  "不可打款-未履约": "Not Payable - Not Delivered",
  "可打款-已履约": "Payable - Delivered"
};
